<template>

    <v-form id="form_file_import" ref="form_file_import">

        <v-container v-if="!isEmpty" fluid grid-list-md class="pa-0 button-file-upload" :class="'button-file-upload_extension_' + extension">
          <v-flex column >
            <v-layout row justify-start>

              <v-flex xs1 v-if="!isEmpty" style="display: flex; justify-content: center;"  >
                <span class="fiv-viv button-file-upload__control" :class="['fiv-size-'+ size, 'fiv-icon-' + extension]">
                  <input v-if="value==null" :name="name" v-on class="button-file-upload__input" type="file" :multiple="multiple" :accept="accept" v-on:change="onChange">
                </span>
              </v-flex>

              <v-flex >
                <v-layout column fill-height justify-space-around align-start ma-0>
                  <span v-if="filename"> {{ filename }} </span>
                </v-layout>
              </v-flex>

              <v-flex xs6 >
                <v-layout justify-center align-start  ma-1>
                  <v-textarea
                    v-if="!isEmpty && value != null"
                    v-model="getDescription"
                    auto-grow
                    solo
                    flat
                    full-width
                    @change="onChange"
                    :placeholder="$t('add description')"
                    rows="1"
                    hide-details
                  ></v-textarea>
                </v-layout>
              </v-flex>

            </v-layout>

          </v-flex>
        </v-container>

    </v-form>

</template>

<script>

    import './../styles'

    export default {

        name: 'file-upload',
        props: {

            name: {

                type: String,
                default: () => {

                    let randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26))
                    return 'files-' + randLetter + Date.now()

                }

            },

            callback: {

                type: Function,
                default: null
            },

            title: {

                type: String,
                default: null
            },

            data: {

                type: [Object, String, Array],
                default: ''
            },

            size: {

                type: String,
                default: 'md'
            },

            // TODO
            multiple: {

                type: Boolean,
                default: false
            },

            value: {

                type: [Object, Array, String, File],
                default: null

            },

            accept: {

                type: String,
                default: "*"

            },

            icon: {

                type: String,
                default: 'blank'

            },

        },

        data: function () {

            return {

                filename: '',
                description: '',
                extension: 'blank',
                isEmpty: true,
                files: [],

            }

        },

        computed: {

            fileList: function () {

                return this.files

            },

            getDescription: {

              get: function () {

                return this.value.data.description

              },

              set: function (newVal) {

                this.description = newVal

              },

            }

        },

        created: function () {

            this.extension = this.icon
            // console.log('VALUE', this.value)
            if (this.value !== null) {

                this.filename = this.value.name
                this.description = this.value.data.description
                this.extension = this.filename.split('.').pop().toLowerCase() || this.icon
                this.isEmpty = false
            }

        },

        updated: function () {
            // console.log('updated VALUE', this.value)
            if (this.value!==null)
            {
                this.filename = this.value.name;
                this.description = this.description != '' ? this.description : this.value.data.description
                this.extension = this.filename.split('.').pop().toLowerCase();
                this.isEmpty = false;
            }
        },

        methods: {

            onDelete: function () {

                this.$emit('delete')

            },

            onChange: function (e) {

                console.log('onChange STARTED', e)

                if (this.callback) {

                    if (e.target.files.length) {

                        this.callback(e.target.files)

                    } else {

                        this.callback(null)

                    }

                } else {

                    if (this.isEmpty) {

                        this.isEmpty = false

                        let $_payload = e.target.files[0]
                        if (this.multiple) {

                            $_payload = []

                            Object.keys(e.target.files).map(index => {

                                $_payload.push(e.target.files[index])

                            })

                        }

                        this.$emit('change', $_payload, this.name)
                        // console.log('change', $_files)

                        // if (this.multiple) {
                        //
                        //
                        //
                        // }

                    } else {

                        // this.filename = e.target.files[0].name
                        // this.description = e.target.files[0].description
                        // this.extension = this.filename.split('.').pop().toLowerCase()
                        console.log('onChange EMITED', e)
                        this.$emit('change', e)



                    }

                }

            },

            reset: function () {

                // alert('reset')
                // console.log('RESET')

                this.$el.reset()
                // console.log('THIS $EL', this.$el)
                this.filename = ''
                this.description = ''
                this.extension = this.icon
                this.isEmpty = true
                this.files = []

            }

        }

    }
</script>

<style lang="stylus" scoped>

    .button-file-upload

        position: relative
        box-sizing: border-box

        &_extension

            &_blank

                padding-left: 0;
                border-color: transparent

            &_new

                padding-left: 0;
                border-color: transparent

        &__area

            display: flex
            justify-content: center

            width: 80px
            height: 80px

            border-radius: 50%
            border: 1px solid alpha(#000, .4)

        &__control

            position: relative
            overflow: hidden
            z-index: 2

            cursor: pointer

            &.fiv-icon-blank

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

            &.fiv-icon-new

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

        &__overlay

            position: absolute

            top: 0
            right: 0
            bottom: 0
            left: 0

            margin-right: -8px

            width: 100%
            /* height */

            background: alpha(#fff, .9)

            opacity: 0
            transition: opacity .4s

            &:hover

                opacity: 1

        &__delete

            cursor: pointer

            margin-right: -16px
            margin-top: -16px

            opacity: .5
            transition: opacity .4s

            &:hover

                opacity: 1

        &__input

            display: block
            position: absolute

            top: 0
            right: 0

            min-width: 100%
            min-height: 100%

            text-align: right

            opacity: 0
            outline: none
            cursor: inherit

        &__name

            display: block /* Fallback for non-webkit */
            max-height: calc(20px * 2) /* Fallback for non-webkit */
            min-height: calc(20px * 2) /* Fallback for non-webkit */
            margin: 0 auto
            font-size: 12px
            line-height: 16px
            -webkit-line-clamp: 3
            -webkit-box-orient: vertical
            overflow: hidden
            text-overflow: ellipsis
            word-break: break-all
            text-align: center;


</style>
